import { useMemo } from 'react';
import { useApolloClients } from '@core/context/ApolloClientsContext';

/** Stable comma-sorted shop id key — use in effect deps instead of `shops` array identity. */
export function useShopIdsKey(): string {
  const { shops } = useApolloClients();
  return useMemo(
    () =>
      shops
        .map(s => s.id)
        .filter(Boolean)
        .sort()
        .join(','),
    [shops]
  );
}

export function parseShopIdsKey(shopIdsKey: string): string[] {
  if (!shopIdsKey) return [];
  return shopIdsKey.split(',').filter(Boolean);
}
